// Returns "ios", "android", or null (desktop/unknown). iPadOS Safari reports a
// Mac user agent, so a "Macintosh" UA with touch support is treated as iOS.
export const getMobilePlatform = () => {
  if (typeof navigator === "undefined") return null;
  const ua = navigator.userAgent || "";
  if (/android/i.test(ua)) return "android";
  if (/iphone|ipad|ipod/i.test(ua)) return "ios";
  if (/macintosh/i.test(ua) && navigator.maxTouchPoints > 1) return "ios";
  return null;
};
